export const theme = {
    color: {
        lightGreen: "#00E676",
        darkerBlue: "#0288D1",
        white: "#ffffff",
        black: "#000000",
        darkerGreen: "#388e3c",
    },
    fontFamily: "'Montserat', sans-serif",
}